import React, { useState, useEffect,useContext } from "react";
import { getAllLessonsWithParams,deleteLesson } from "../api/Api";
import { showToast } from "../utils/toastUtils";
import HeaderAndFilters from "./HeadersAndFilters";
import {ProjectContext} from "../contexts/ProjectContextProvider";
import ListItems from "./ListItems";
import AddNewLesson from "./modals/AddNewLesson";
import UpdateLessonModal from "./modals/UpdateLessonModel";
import { TbBulb } from "react-icons/tb";


function LessonsForWorkStream({ organizationId, workStreamId,createdBy,setShowAddLessonModal,showAddLessonModal,handleAddLesson }) {
  const { data: projectData } = useContext(ProjectContext);
  const [lessons, setLessons] = useState([]);
  const [loading,setLoading] = useState(true);
  const [error,setError] = useState(null);
  const [filters, setFilters] = useState({});
  const [filteredLessons, setFilteredLessons] = useState([]);
  const [showUpdateLessonModal, setShowUpdateLessonModal] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);
 
  const projectOptions = projectData?.map(project => ({
  name: project?.name, // Display name in filter dropdown
  id: project?.id    // Use id as the value to identify the selected option
  })) || [];

  useEffect(() => {
    const fetchLessons = async () => {
      try {
        //  Get all lessons (without user filter) for dropdown
        const allLessonsResponse = await getAllLessonsWithParams(organizationId, workStreamId,filters.project,filters.user);

        if (allLessonsResponse.status !== 200) {
          showToast(allLessonsResponse.message || "Failed to fetch lessons", "error");
          return;
        }

        const uniqueCreatedBy = [
          ...new Set(allLessonsResponse.data.map((lesson) => JSON.stringify(lesson.created_by)))
        ];

        const createdByOptions = uniqueCreatedBy.map((userStr) => {
          const user = JSON.parse(userStr);
          return {
            name: `${user.first_name} ${user.last_name}`,
            id: user.id,
          };
        });

        // Fetch filtered lessons based on selected createdBy
        const filteredLessonsResponse = await getAllLessonsWithParams(
          organizationId,
          workStreamId,
          createdBy
        );

        if (filteredLessonsResponse.status === 200) {
          setLessons(filteredLessonsResponse.data);
          setFilters((prevFilters) => ({
            ...prevFilters,
            createdByOptions,
          }));
        } else {
          showToast(filteredLessonsResponse.message || "Failed to fetch filtered lessons", "error");
        }

      } catch (error) {
        showToast("Failed to fetch lessons", "error");
        console.error("Error fetching lessons:", error);
        setError("Failed to fetch lessons. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

  if (organizationId && workStreamId) {
    fetchLessons();
  }
}, [organizationId, workStreamId, createdBy]);




  //Filter lessons based on search input

  useEffect(() => {
    if (!filters.search) {
      setFilteredLessons(lessons);
      return;
    }

    const filtered = lessons.filter((lesson) => {
      const title = lesson.title?.toLowerCase() || "";
      const description = lesson.description?.toLowerCase() || "";
      return title.includes(filters.search.toLowerCase()) || description.includes(filters.search.toLowerCase());
    });

    setFilteredLessons(filtered);
  }, [filters.search, lessons]);



    if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

 //function to add new lesson 
const handleAddNewLesson =(newLesson) => {
  setLessons((prevLessons) => [...prevLessons, newLesson]);
};


const handleUpdateLesson = (updatedLesson) => {
    setLessons((prevLessons) =>
      prevLessons.map((lesson) =>
        lesson.id === updatedLesson.id ? updatedLesson : lesson
      )
    );
  };

  const handleOpenModal = () => { setShowAddLessonModal(true); }; 
  const handleCloseModal = () => { setShowAddLessonModal(false); };
  
  const openUpdateLessonModal = (lesson) => {
    setSelectedLesson(lesson);
    setShowUpdateLessonModal(true);
  };
  const closeUpdateLessonModal = () => {
    setSelectedLesson(null);
    setShowUpdateLessonModal(false);
  };

  
  
  const handleDelete = async (lessonId) => {
    try {
      const response = await deleteLesson(lessonId);
      if (response.status === 200) {
        showToast("Lesson deleted successfully", "success");
        setLessons((prevLessons) => prevLessons.filter((lesson) => lesson.id !== lessonId));
      } else {
        showToast(response.message || "Failed to delete Lesson", "error");
      }
    } catch (error) {
      showToast("Failed to delete Lesson", "error");
      console.error("Error deleting Lesson:", error);
    }
  };


const handleFilterChange = (newFilters) => {
  setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
};



  return (
    <div>
      <HeaderAndFilters
        filters={filters}
        showHeader={false}
        headerIcon={<TbBulb  size={40} />}
        headerTitle="Lessons List"
        projectOptions={projectOptions}
        workstreamOptions={[{ label: "Workstream 1", value: 1 }, { label: "Workstream 2", value: 2 }]}
        createdByOptions={filters.createdByOptions || []}
        handleClick={handleOpenModal}
        onFilterChange={handleFilterChange}
        newButtonText="NEW LESSON"
        searchPlaceholder="Search..."
        showProjectButton={false}
        showWorkstreamButton={false}
        showCreatedByButton={true}
      />
        <ListItems
            items={filteredLessons}
            onEdit={openUpdateLessonModal}
            onDelete={handleDelete}
            titleField={lessons.name}
            descriptionField={lessons.description}
            dateField={lessons.created_at}
            avatarField={lessons.created_by}
             noItemsMessage='No lessons to display. To add a new lesson, click on the "NEW LESSON" button.'
      />
      <AddNewLesson
       show={showAddLessonModal}
       handleClose={handleCloseModal}
       onAddLesson={handleAddNewLesson}
       workStreamId={workStreamId}
       />
      {selectedLesson && (
        <UpdateLessonModal
          show={showUpdateLessonModal}
          handleClose={closeUpdateLessonModal}
          lesson={selectedLesson}
          onUpdateLesson={handleUpdateLesson} 
          workStreamId={workStreamId}
        />
      )} 

    </div>
  );
}

export default  LessonsForWorkStream;